export const NoAttachmentsModal: string = 'NoAttachmentsModal';
